export const containerSizes = [
  { value: '20ft' },
  { value: '40ft' },
  { value: '40ft_hc' },
  { value: '20ft_flat' },
  { value: '40ft_flat' },
  { value: '20ft_open_top' },
  { value: '40ft_open_top' },
  { value: '20ft_reefer' },
  { value: '40ft_reefer' },
  { value: '40ft_hc_reefer' }
];

function containerSizeOptions(translator: any): any[] {
  return containerSizes.map(c => ({ ...c, label: translator(`cargo.sizes.${c.value}`) }));
}

export default containerSizeOptions;
